import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const categoriesWithImages = [
  {
    name: 'Buty',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20white%20designer%20sneakers%20placed%20on%20cream%20textured%20fabric%20with%20natural%20sunlight%20casting%20soft%20diagonal%20shadows%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20end%20fashion%20editorial%20style%2C%20subtle%20linen%20texture%20background%2C%20sophisticated%20European%20look&width=400&height=320&seq=cat-shoes-2026-v2&orientation=landscape",
  },
  {
    name: 'Bluzy/Swetry',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Premium%20quality%20oversized%20beige%20hoodie%20folded%20neatly%20on%20light%20oak%20wooden%20surface%2C%20soft%20morning%20light%20from%20side%20window%2C%20cozy%20texture%20visible%2C%20warm%20cream%20and%20sand%20tones%2C%20minimalist%20fashion%20product%20photography%2C%20editorial%20catalog%20style%2C%20clean%20Scandinavian%20aesthetic&width=400&height=320&seq=cat-hoodies-2026-v2&orientation=landscape",
  },
  {
    name: 'Koszulki',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20premium%20cotton%20tshirts%20in%20soft%20pastel%20colors%20on%20white%20marble%20surface%2C%20natural%20daylight%2C%20clean%20and%20fresh%20aesthetic%2C%20minimalist%20fashion%20product%20display%2C%20editorial%20clothing%20photography%2C%20gentle%20shadows%2C%20sophisticated%20retail%20style&width=400&height=320&seq=cat-tshirts-2026-v2&orientation=landscape",
  },
  {
    name: 'Kurtki',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20wooden%20hanger%20against%20warm%20cream%20wall%2C%20soft%20studio%20lighting%2C%20premium%20fabric%20texture%20visible%2C%20modern%20streetwear%20aesthetic%2C%20editorial%20fashion%20product%20photography%2C%20minimal%20composition%2C%20sophisticated%20casual%20style&width=400&height=320&seq=cat-jackets-2026-v2&orientation=landscape",
  },
  {
    name: 'Spodnie/Szorty',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Tailored%20beige%20chino%20pants%20neatly%20laid%20flat%20on%20light%20textured%20linen%20fabric%2C%20natural%20daylight%20illumination%2C%20visible%20fabric%20weave%20detail%2C%20minimalist%20menswear%20product%20photography%2C%20clean%20editorial%20composition%2C%20warm%20neutral%20palette%2C%20sophisticated%20casual%20elegance&width=400&height=320&seq=cat-pants-2026-v2&orientation=landscape",
  },
  {
    name: 'Nakrycia głowy',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20in%20soft%20sand%20color%20resting%20on%20smooth%20stone%20surface%2C%20warm%20afternoon%20sunlight%2C%20visible%20fabric%20stitching%20detail%2C%20minimalist%20headwear%20product%20photography%2C%20clean%20composition%2C%20subtle%20texture%20contrast%2C%20modern%20street%20style%20aesthetic&width=400&height=320&seq=cat-headwear-2026-v2&orientation=landscape",
  },
  {
    name: 'Zestawy',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20set%20including%20jacket%20shirt%20and%20pants%20artfully%20arranged%20on%20cream%20backdrop%2C%20soft%20diffused%20studio%20light%2C%20cohesive%20color%20palette%20in%20warm%20earth%20tones%2C%20editorial%20lifestyle%20product%20photography%2C%20clean%20modern%20composition%2C%20sophisticated%20styling&width=400&height=320&seq=cat-sets-2026-v2&orientation=landscape",
  },
  {
    name: 'Bielizna',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20set%20in%20soft%20neutral%20tones%20displayed%20on%20smooth%20marble%20surface%2C%20clean%20elegant%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20sophisticated%20intimate%20apparel%20presentation%2C%20warm%20gentle%20shadows%2C%20refined%20editorial%20style&width=400&height=320&seq=cat-underwear-2026-v2&orientation=landscape",
  },
  {
    name: 'Koszulki sportowe',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Athletic%20performance%20jersey%20in%20deep%20forest%20green%20with%20subtle%20mesh%20texture%20laid%20flat%20on%20light%20grey%20concrete%20surface%2C%20dynamic%20product%20photography%2C%20visible%20breathable%20fabric%20pattern%2C%20modern%20sportswear%20aesthetic%2C%20clean%20composition%2C%20studio%20lighting%2C%20professional%20athletic%20wear%20presentation&width=400&height=320&seq=cat-jersey-2026-v2&orientation=landscape",
  },
  {
    name: 'Akcesoria',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Collection%20of%20premium%20fashion%20accessories%20including%20sunglasses%20watch%20and%20bracelet%20arranged%20on%20warm%20terracotta%20fabric%2C%20golden%20hour%20natural%20light%2C%20sophisticated%20product%20flat%20lay%2C%20elegant%20composition%2C%20rich%20warm%20tones%2C%20editorial%20accessory%20photography%2C%20refined%20European%20style&width=400&height=320&seq=cat-accessories-2026-v2&orientation=landscape",
  },
  {
    name: 'Torby',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Elegant%20leather%20tote%20bag%20in%20warm%20cognac%20brown%20placed%20on%20cream%20linen%20surface%2C%20natural%20window%20light%2C%20visible%20leather%20grain%20texture%2C%20minimalist%20handbag%20product%20photography%2C%20sophisticated%20accessory%20presentation%2C%20clean%20composition%2C%20refined%20luxury%20aesthetic&width=400&height=320&seq=cat-bags-2026-v2&orientation=landscape",
  },
  {
    name: 'Paski',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20with%20brushed%20metal%20buckle%20coiled%20elegantly%20on%20smooth%20warm%20grey%20surface%2C%20soft%20studio%20lighting%2C%20visible%20leather%20texture%20and%20stitching%20detail%2C%20minimalist%20accessory%20product%20photography%2C%20clean%20sophisticated%20composition%2C%20refined%20craftsmanship%20aesthetic&width=400&height=320&seq=cat-belts-2026-v2&orientation=landscape",
  },
  {
    name: 'Perfumy',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20with%20amber%20glass%20and%20gold%20accents%20on%20white%20marble%20surface%2C%20soft%20diffused%20light%20with%20gentle%20reflections%2C%20elegant%20fragrance%20product%20photography%2C%20minimalist%20composition%2C%20sophisticated%20beauty%20aesthetic%2C%20warm%20ambient%20glow%2C%20refined%20cosmetic%20presentation&width=400&height=320&seq=cat-perfumes-2026-v2&orientation=landscape",
  },
  {
    name: 'Inne',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    img: "https://readdy.ai/api/search-image?query=Curated%20assortment%20of%20lifestyle%20products%20including%20gadgets%20stationery%20and%20small%20accessories%20on%20warm%20beige%20surface%2C%20natural%20daylight%2C%20modern%20product%20flat%20lay%2C%20diverse%20collection%20of%20trendy%20items%2C%20editorial%20catalog%20photography%2C%20clean%20Scandinavian%20aesthetic%2C%20harmonious%20composition&width=400&height=320&seq=cat-other-2026-v2&orientation=landscape",
  },
];

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            {t('categories.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categoriesWithImages.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full aspect-[5/4] overflow-hidden bg-background-200">
                <img
                  src={cat.img}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            Zobacz wszystkie kategorie w naszym przewodniku
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}